export default "Take a look at my next project.";